import { useEffect, useState } from 'react';

export function irA(ruta: string): void {
  window.history.pushState({}, '', ruta);
  window.dispatchEvent(new PopStateEvent('popstate'));
}

export function pathDe(ruta: string): string {
  const corte = ruta.indexOf('?');
  return corte === -1 ? ruta : ruta.slice(0, corte);
}

export function consultaDe(ruta: string): URLSearchParams {
  const corte = ruta.indexOf('?');
  return new URLSearchParams(corte === -1 ? '' : ruta.slice(corte + 1));
}

export function useRuta(): string {
  const [ruta, setRuta] = useState(() => `${window.location.pathname}${window.location.search}`);

  useEffect(() => {
    const alCambiar = (): void => setRuta(`${window.location.pathname}${window.location.search}`);
    window.addEventListener('popstate', alCambiar);
    return () => window.removeEventListener('popstate', alCambiar);
  }, []);

  return ruta;
}
